<template>
    <main class="home">
        <hk-header></hk-header>
        <!-- <hk-screen></hk-screen> -->
        <div class="home-container flex">
            <c-side-bar></c-side-bar>
            <router-view></router-view>
        </div>
        <hk-footer theme="dark"></hk-footer>
    </main>
</template>

<script>
import HkHeader from '@components/HkHeader';
import HkFooter from '@components/HkFooter';
import CSideBar from '@components/CSideBar';

export default {
    name: 'Home',
    components: {
        HkHeader,
        CSideBar,
        HkFooter
    }
};
</script>
<style lang="scss" scoped>
.home {
    padding-top: 83px;
    background: #f7f6f6;
    .home-container {
        width: 1200px;
        min-height: calc(100vh - 203px);
        margin: 0 auto;
        background-color: #fff;
        border-radius: 0px 24px 0px 0px;
    }
}
</style>
